import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../../common/Fieldset";
import Row from "../../common/Row";
import Files from "../../common/Files";
import ReadonlyFiles from "../../common/ReadonlyFiles";
import RadioButtonGroup from "../../common/RadioButtonGroup";
import TextAreaInput from "../../common/TextAreaInput";
import { getFilesComponentProps, getFiles } from "../../common/FilesHelperUtil";
import { FileComponentNames } from "../../../constants/ComponentConstants";
import { ToelatingTypes } from "../../../constants/DomainConstants";

function getFieldsetTitle(type, gemeente) {
	let text = "";

	switch (type) {
		case ToelatingTypes.ANB:
			text = "Machtiging ANB";
			break;
		case ToelatingTypes.AWV:
				text = "Machtiging AWV";
				break;
		case ToelatingTypes.GEMEENTE:
			text = `Goedkeuring ${gemeente}`;
			break;
		case ToelatingTypes.ANDERE:
			text = "";
			break;
	}

	return text;
}

function getQuestionText(type, gemeente, heeftBepijling) {
	let text = "";

	switch (type) {
		case ToelatingTypes.ANB:
			text = "Deze tocht beschikt over de machtiging van ANB";
			break;
		case ToelatingTypes.AWV:
			text = "Deze tocht beschikt over de machtiging van AWV";
			break;
		case ToelatingTypes.GEMEENTE:
			text = `${gemeente} geeft goedkeuring voor deze tocht${heeftBepijling ? " met bepijling" : ''}`;
			break;
		case ToelatingTypes.ANDERE:
			text = "Deze tocht beschikt over andere goedkeuringen";
			break;
	}

	return text;
}

const Toelating = (props) => {
	const {
		disabled,
		onChange,
		getError,
		downloadFileUrl,
		fileComponents,
		onDropFiles,
		onDeleteFile,
		color,
		bewijsstukkenFileTypes,
		model,
		validationMessageType,
		hideTitle,
		heeftBepijling
	} = props;

	const disableAll = disabled || model.type === ToelatingTypes.ANB || model.type === ToelatingTypes.AWV;

	const filesComponentTitle = model.type === ToelatingTypes.ANB ? "Antwoord van ANB" : model.type === ToelatingTypes.AWV ? "Antwoord van AWV" :"Bewijsstuk(ken)";

	const fileProps = getFilesComponentProps(
		filesComponentTitle,
		FileComponentNames.BEWIJSSTUKKEN_TOELATING_ + (model.id ? model.id.split('-').join('') : ''),
		downloadFileUrl,
		fileComponents,
		(model.type === ToelatingTypes.ANB || model.type === ToelatingTypes.AWV),
		onDropFiles,
		onDeleteFile,
		bewijsstukkenFileTypes,
		true,
		null,
		null,
		color);

	const hasFiles = getFiles(fileComponents, FileComponentNames.BEWIJSSTUKKEN_TOELATING_ + (model.id ? model.id.split('-').join('') : '')).length;

	let fieldsetTitle = getFieldsetTitle(model.type, model.gemeenteNaam);
	if (hideTitle === true) fieldsetTitle = "";

	const qText = getQuestionText(model.type, model.gemeenteNaam, heeftBepijling);

	const radiobuttonItems = model.type === ToelatingTypes.GEMEENTE ? [{ value: true, label: "Ja" }, { value: false, label: "Nee" }, { value: '', label: "Onbeslist" }] : [{ value: true, label: "Ja" }, { value: false, label: "Nee" }];

	let gelinkteToelatingAttachments = model.gelinkteToelatingAttachments && model.gelinkteToelatingAttachments.map(model =>
		<ReadonlyFiles
			title={`Gewijzigde route voor de afstand "${model.displayName}"`}
			color="red"
			ownerId={model.ownerId}
			componentName={FileComponentNames.GEWIJZIGDE_GPX}
			center
			/>
	);

	return <Fieldset title={fieldsetTitle} >
		<Row>
			<RadioButtonGroup
				label={qText}
				labelInside
				name={"toelatingOK_" + model.id}
				key={"toelatingOK_" + model.id}
				value={model.toelatingOK}
				horizontal
				disabled={disableAll}
				validationMessage={getError("toelatingOK")}
				validationMessageType={validationMessageType}
				items={radiobuttonItems}
				onChange={onChange}
				optional={model.type == ToelatingTypes.ANDERE}
				locked={hasFiles && !disableAll} />
		</Row>
		{(!disableAll || (disableAll && model.opmerkingen)) ?
			<Row>
				<TextAreaInput
					name="opmerkingen"
					label={(model.type !== ToelatingTypes.ANB && model.type !== ToelatingTypes.AWV) ? "Opmerkingen (max 500 tekens)" : "Opmerkingen"}
					value={model.opmerkingen}
					onChange={onChange}
					validationMessage={getError("opmerkingen")}
					validationMessageType={validationMessageType}
					optional={model.type === ToelatingTypes.ANDERE}
					disabled={disableAll}
					maxLength={500}
				/>
			</Row> : null}
		{(model.toelatingOK === true || model.toelatingOK === "true" || model.type === ToelatingTypes.ANB || model.type === ToelatingTypes.AWV) &&
			<Row>
				<Files
					{...fileProps}
					disabled={disableAll}
					optional={model.type === ToelatingTypes.ANDERE}
					validationMessage={getError("ulBewijsstukken")}
					validationMessageType={validationMessageType} />
			</Row>
		}
		{
			model.gelinkteToelatingAttachments && gelinkteToelatingAttachments
		}

	</Fieldset>;
};

Toelating.propTypes = {
	model: PropTypes.object.isRequired,
	downloadFileUrl: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
	fileComponents: PropTypes.object.isRequired,
	onDropFiles: PropTypes.func.isRequired,
	onDeleteFile: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	getError: PropTypes.func.isRequired,
	color: PropTypes.string.isRequired,
	bewijsstukkenFileTypes: PropTypes.object.isRequired,
	validationMessageType: PropTypes.string,
	hideTitle: PropTypes.bool,
	heeftBepijling: PropTypes.bool
};

export default Toelating;
